import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataMonitoringEnrollmentsComponent } from './data-monitoring-enrollments/data-monitoring-enrollments.component';
import { DataMonitoringService } from './service/data-monitoring.service';
import { MaterialModule } from 'src/app/material/material.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { DataMonitoringReportsRoutingModule } from './data-monitoring-reports-routing.module';
import { DataMonitoringEnrollmentsSimplifiedComponent } from './data-monitoring-enrollments-simplified/data-monitoring-enrollments-simplified.component';
import { DataMonitoringServicesComponent } from './data-monitoring-services/data-monitoring-services.component';
import { DataMonitoringEnrollmentsDividedComponent } from './data-monitoring-enrollments-divided/data-monitoring-enrollments-divided.component';
import { GradeAgeAlignmentComponent } from './grade-age-alignment/grade-age-alignment.component';
import { GradeAgeAlignmentStudentDialogComponent } from './grade-age-alignment/grade-age-alignment-student-dialog/grade-age-alignment-student-dialog.component';
import { ChildrenModule } from '../children/children.module';
import { ViewGradeAlignmtTableComponent } from './grade-age-alignment/view-grade-alignmt-table/view-grade-alignmt-table.component';
import { ViewGradeIntersectComponent } from './grade-age-alignment/view-grade-intersect/view-grade-intersect.component';
import { ObjectToArrayPipe } from './grade-age-alignment/view-grade-alignmt-table/object-to-array.pipe';
import { ViewGradeIntersectBtnComponent } from './grade-age-alignment/view-grade-alignmt-table/view-grade-intersect-btn/view-grade-intersect-btn.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ProvisionalSchoolComponent } from './provisional-school/provisional-school.component';

@NgModule({
    declarations: [
        DataMonitoringEnrollmentsComponent,
        DataMonitoringEnrollmentsSimplifiedComponent,
        DataMonitoringServicesComponent,
        DataMonitoringEnrollmentsDividedComponent,
        GradeAgeAlignmentComponent,
        GradeAgeAlignmentStudentDialogComponent,
        ViewGradeAlignmtTableComponent,
        ViewGradeIntersectComponent,
        ObjectToArrayPipe,
        ViewGradeIntersectBtnComponent,
        ProvisionalSchoolComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,        
        FormsModule,
        PipesModule,
        CommonComponentsModule,
        DataMonitoringReportsRoutingModule,
        ChildrenModule,
        MatProgressBarModule
    ],
    exports: [],
    providers: [DataMonitoringService]
})
export class DataMonitoringReportsModule {}
